export default "__VITE_ASSET__87b530a6__"